// import Textarea from 'react-native-textarea';
import React, { useState, useEffect } from "react";
import { PixelRatio, Platform, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { useNavigation } from "@react-navigation/native";
import { useGlobalState } from "../../shared/state";
import { I18N, sleep } from "../../shared/util";
import { Fonts, Styles } from "../../styles";
import CustomCheckBox from "../../components/Checkbox/CustomCheckBox";

const Consent: React.FC = (): JSX.Element => {
  const [currentScanner] = useGlobalState("currentScanner");
  const [currentUser] = useGlobalState("currentUser");
  const [language] = useGlobalState("language");
  const [, setRoute] = useGlobalState("currentScreen");
  const [region] = useGlobalState("region");

  const [sendButtonDisabled, setSendButtonDisabled] = useState<Boolean>(false);
  const [termsAndConditions, setTermsAndConditions] = useState<boolean>(false);
  const [submitted] = useState(false);

  const navigation = useNavigation();
  const i18n = I18N(language);

  const navigate = (route: string | undefined, options: any = undefined) => {
    if (route) {
      navigation.push(route, options);
      setRoute(route);
    }
  };

  useEffect(() => {
    if (sendButtonDisabled) sleep(10000).then(() => setSendButtonDisabled(false));
  }, [sendButtonDisabled]);

  const getNextScreen = () => {
    if (currentScanner && currentScanner["mandatoryLogin"]) {
      if (currentUser) {
        return "NewScanGenderSelection";
      } else {
        if (Platform.OS === "web") {
          return "Login";
        } else {
          return "LoginModal";
        }
      }
    } else {
      return "NewScanGenderSelection";
    }
  };

  const getCheckBoxValue = () => {
    setTermsAndConditions(!termsAndConditions);
  };

  const isMissingTranslation = (value: unknown): boolean => typeof value === "string" && value.startsWith("[missing");

  const getConsentText = (region: string, consentIndex: 1 | 2 | 3 | 4): string => {
    const regionKey = `consents.${region.toLowerCase()}Consent${consentIndex}`;
    const regionValue = i18n.t(regionKey);

    if (!isMissingTranslation(regionValue)) {
      return regionValue;
    }

    const fallbackKey = `consents.germanyConsent${consentIndex}`;
    return i18n.t(fallbackKey);
  };

  // usage
  const consentText1 = getConsentText(region, 1);
  const consentText2 = getConsentText(region, 2);
  const consentText3 = getConsentText(region, 3);
  const consentText4 = getConsentText(region, 4);

  return (
    <LayoutWrapper showHeaderCloseButton={false} title={i18n.t("consents.title").toUpperCase()} showMenuButtons={false} hideInfoButton={true} hideBackButton showBirkenstockFooter showBirkenstockFooterLogo showBirkenstockHomeButton>
      <View style={[Styles.contentWrapperFull, Styles.column]}>
        <View style={styles.wrapper}>
          {/* <View style={styles.header}>
            <Text style={[Fonts.pageTitle, { color: "#0e2288", fontSize: 40, fontFamily: "Birkentype" }]}>{i18n.t("consents.title").toUpperCase()}</Text>
          </View> */}
          <View style={styles.container}>
            <View style={styles.contentWrapper}>
              <ScrollView style={{ width: "90%", height: "100%" }} showsVerticalScrollIndicator>
                <Text style={[Fonts.text, { fontSize: 19.2, fontFamily: "Geist-Light" }]}>
                  {consentText1[0]}
                  {consentText1[1]}
                  {consentText1[2]}
                </Text>
                <Text style={[Fonts.text, { fontSize: 19.2, marginTop: "2.5%", marginBottom: "2.5%", fontFamily: "Geist-Light" }]}>
                  {consentText2[0]}
                  <TouchableOpacity onPress={() => navigate("PrivacyPolicy")} >
                    <Text style={{ textDecorationLine: "underline", color: "#0e2288" }}>{consentText2[1]}</Text>
                  </TouchableOpacity>
                </Text>
                <Text style={[Fonts.text, { fontSize: 19.2, fontFamily: "Geist-Light" }]}>
                  <strong>{consentText3[0]}</strong>
                  {"\n"}
                  {consentText3[1]}
                  {"\n"}
                  {"\n"}
                  {consentText3[2]}
                </Text>
                <Text style={[Fonts.text, { fontSize: 19.2, fontFamily: "Geist-Light" }]}>
                  {"\n"}
                  <strong>{consentText4[0]}</strong>
                  {"\n"}
                  {consentText4[1]}
                  {"\n"}
                  {"\n"}
                  {consentText4[2]}
                  <TouchableOpacity onPress={() => navigate("PrivacyPolicy")} >
                    <Text style={{ textDecorationLine: "underline", color: "#0e2288" }}>{consentText2[1]}</Text>
                  </TouchableOpacity>
                </Text>
              </ScrollView>
            </View>
          </View>
          <View style={{ flexDirection: "row", alignSelf: "center", width: "85%", height: "15%", marginTop: "1%", justifyContent: "space-between", alignItems: "center" }}>
            <View style={{ height: "100%", width: "65%", justifyContent: "center", fontFamily: "Birkentype" }}>
              <CustomCheckBox text={i18n.t("consents.agreeText")} submitted={submitted} parentCallback={getCheckBoxValue} termsAndConditions={termsAndConditions} hidePrivacyPolicy isSquareIcon />
            </View>
            <TouchableOpacity
              style={[styles.button, { backgroundColor: !termsAndConditions ? "#cbcdce" : "#0e2288", width: 335, padding: 0, height: 77, justifyContent: "center", alignItems: "center" }]}
              onPress={() => navigate(getNextScreen(), { resetState: true })}
              disabled={!termsAndConditions}
            >
              <Text style={[Fonts.squareMenuButtonCaption, { color: "white", fontSize: 36, fontFamily: "Birkentype" }]}>{i18n.t("next")}</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </LayoutWrapper>
  );
};

export default Consent;

const styles = StyleSheet.create({
  wrapper: {
    height: "100%",
    width: "85%",
    flexDirection: "column",
    justifyContent: "flex-start",
    paddingTop: "2%",
  },
  header: {
    height: "12%",
    width: "100%",
    paddingTop: "2%",
    paddingBottom: "3%",
    paddingLeft: "2%",
  },
  container: {
    width: "85%",
    height: "70%",
    alignSelf: "center",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "2%",
    shadowColor: "#000",
    shadowOffset: { width: 6 / PixelRatio.get(), height: 6 / PixelRatio.get() },
    shadowOpacity: 0.16,
    shadowRadius: 4 / PixelRatio.get(),
    elevation: 1,
  },
  contentWrapper: {
    // flex: 1,
    height: "100%",
    minWidth: "90%",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    paddingTop: "2%",
  },
  button: {
    padding: 12,
    borderRadius: 6,
    boxShadow: "0px 4px 6px #00000029",
    height: "25%",
  },
});
